import { Checkbox, FormControl, FormControlLabel, InputLabel } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller, useFormContext } from "react-hook-form";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import Select from 'react-select';
import ptBR from "date-fns/locale/pt-BR";
import styles from "../Cadastro.module.css";
import { TensaoFornecimentoSearchField } from "../../../../components/Searchfields/TensaoFornecimento";
import { useEffect, useState } from "react";
import { FabricantesSearchField } from "../../../../components/Searchfields/Fabcricantes";

const selectStyles = {
    control: (styles, { isDisabled, readOnly }) => ({
        ...styles,
        marginTop: '15px',
        color: isDisabled || readOnly ? '#B8B8B8' : '#707070',
        border: isDisabled || readOnly ? '1px solid #5f5f5f' : '',
        backgroundColor: isDisabled || readOnly ? '#565656' : '#343434',
        borderRadius: "10px",
        padding: "3px"
    }),
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            backgroundColor: isDisabled ? '#565656' : '#343434',
            color: '#707070',
            border: 'none',
        }
    },
    input: (styles) => ({ ...styles, color: "#707070" }),
    singleValue: (styles, { isDisabled, readOnly }) => ({ ...styles, color: isDisabled || readOnly ? "#B8B8B8" : "#707070" }),
    menuList: (styles) => ({ ...styles, backgroundColor: "#343434" }),
};


const options = [
    { value: 0, label: "Não se aplica" },
    { value: 1, label: "Monofásica" },
    { value: 2, label: "Bifásica" },
    { value: 3, label: "Trifásica" }
];

const optionsTiposDeEquipamento = [
    { value: 1, label: "Módulo" },
    { value: 2, label: "Inversor" },
    { value: 3, label: "Outros" }
];

const optionsPossuiAFCI = [
    { value: 0, label: "Não informado" },
    { value: 1, label: "Sim" },
    { value: 2, label: "Não" },
];

const Geral = ({ disableCampos, setErrorMessage, setOpenError, setTensaoFornecimento, setCodigoTensaoFornec, tensaotensaoFornecimento, required, setRequired, situacao, setFabricanteCadastrado, fabricanteCadastrado, fabricanteForaLista, setFabricanteForaLista }) => {
    const { control, register, setValue, watch, resetField, formState: { errors } } = useFormContext();
    const watchTipoEquipamento = watch("tipo");
    const watchTensaoFornecimento = watch("tensaoFornecimento");
    const [editavel, setEditavel] = useState(false);
    const watchFabricanteForaLista = watch("fabricanteForaLista");

    useEffect(() => {
        let { value: tipoValue } = watch("tipo");
        const situacaoEditaveis = [0, 2];

        if (tipoValue === 2 && situacaoEditaveis.includes(situacao)) {
            setEditavel(false);
        } else {
            setEditavel(true);
        }
    }, [situacao]);


    useEffect(() => {
        verificarTipoEquipamento();
    }, [watchTipoEquipamento, watchTensaoFornecimento]);

    const verificarTipoEquipamento = () => {
        let { value: tipoValue } = watch("tipo");
        let { value: tensaoValue } = watch("tensaoFornecimento");
        const situacaoEditaveis = [0, 2];

        if (tipoValue !== 2) {
            setTensaoFornecimento(null);
            setValue("tensaoFornecimento", {
                value: null,
                label: null
            });
            setValue("possuiafci", {
                value: 0,
                label: "Não informado"
            });
            setEditavel(true);
            setRequired(false);
        } else if (tipoValue === 2 && situacaoEditaveis.includes(situacao)) {
            setEditavel(false);
        }

        if (tipoValue === 2 && tensaoValue) {
            setRequired(false);
        }
    }

    const handleFabricanteForaLista = (event) => {
        const checked = event.target.checked;

        setFabricanteForaLista(checked);
        setValue("fabricanteForaLista", checked);

        if (checked) {
            resetField("fabricanteCadastrado", { defaultValue: { value: null, label: null } });
            setValue("fabricante", "");
        } else {
            resetField("fabricante", { defaultValue: "" });
            setValue("fabricanteCadastrado", { value: null, label: null });
        }
    };

    return (
        <div>
            <Controller
                name="descricao"
                control={control}
                render={({ field }) => (
                    <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.descricao}>
                        <InputLabel htmlFor="equipamentos-descricao" shrink style={{ color: "#B8B8B8" }} >
                            Descrição
                        </InputLabel>
                        <WhiteInput
                            fullWidth
                            placeholder="Descrição"
                            type="text"
                            id="equipamentos-descricao"
                            error={!!errors.descricao}
                            {...field}
                            readOnly={disableCampos}
                            className={`${errors?.descricao ? styles.campoComValorErrado : ""}`}
                        />
                        {errors?.descricao ? (
                            <HelperText text={errors?.descricao?.message} />
                        ) : ''}
                    </FormControl>
                )}
            />

            <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.tipo}>
                <InputLabel htmlFor="equipamentos-tipo" shrink style={{ color: "#B8B8B8" }} >
                    Tipo de equipamento
                </InputLabel>
                <Controller
                    name="tipo"
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            error={!!errors.tipo}
                            options={optionsTiposDeEquipamento}
                            styles={selectStyles}
                            placeholder="Selecione o tipo de equip."
                            readOnly={disableCampos}
                            isDisabled={disableCampos}
                            className={`${errors?.tipo ? styles.campoComValorErrado : ""}`}
                            onChange={(selected) => {
                                field.onChange(selected);

                                resetField("fabricante", { defaultValue: "" });
                                resetField("fabricanteCadastrado", { defaultValue: { value: null, label: null } });
                                setValue("fabricanteForaLista", false);
                                setFabricanteForaLista(false);
                                setFabricanteCadastrado(null);
                            }}
                        />
                    )}
                />
                {errors?.tipo ? (
                    <HelperText text={"Este campo é obrigatório"} />
                ) : ''}
            </FormControl>

            <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.possuiafci}>
                <InputLabel htmlFor="equipamentos-possuiafci" shrink style={{ color: "#B8B8B8", zIndex: 0 }}>Possui AFCI</InputLabel>
                <Controller
                    name="possuiafci"
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            error={!!errors.possuiafci}
                            options={optionsPossuiAFCI}
                            styles={selectStyles}
                            placeholder="Selecione se possui AFCI"
                            readOnly={editavel || disableCampos}
                            isDisabled={editavel || disableCampos}
                            className={`${errors?.possuiafci ? styles.campoComValorErrado : ""}`}
                        />
                    )}
                />
                {errors?.possuiafci ? (
                    <HelperText text={"Este campo é obrigatório"} />
                ) : ''}
            </FormControl>

            <Controller
                name="tensaoFornecimento"
                control={control}
                render={({ field }) => (
                    <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.tensaoFornecimento}>
                        <InputLabel htmlFor="tensao-fornecimento" shrink style={{ color: "#B8B8B8", zIndex: 0 }}>Tensão nominal (V)</InputLabel>
                        <TensaoFornecimentoSearchField
                            field={field}
                            id="codigoequip-equipamento"
                            setErrorMessage={setErrorMessage}
                            setOpenError={setOpenError}
                            setValue={setTensaoFornecimento}
                            value={tensaotensaoFornecimento}
                            setCodigoTensaoFornec={setCodigoTensaoFornec}
                            editavel={editavel}
                            required={required}
                            className={`${required ? styles.campoComValorErrado : ""}`}
                        />
                        {required ? (
                            <HelperText text={"Este campo é obrigatório"} />
                        ) : ''}
                    </FormControl>
                )}
            />

            <div className={styles['container-checkbox']}>
                <FormControlLabel
                    control=
                    {
                        <Checkbox
                            sx={{
                                color: '#B8B8B8 !important',
                                '&.Mui-checked': {
                                    color: '#6D79EC !important',
                                }
                            }}
                            checked={fabricanteForaLista}
                            onChange={(event) => { handleFabricanteForaLista(event) }}
                            disabled={disableCampos}
                        />
                    }
                    label={<span style={{ fontSize: '13px', color: '#b8b8b8' }}>Fabricante inexistente</span>}
                    labelPlacement="end"
                    className={styles['checkbox']}
                />
            </div>

            {watchFabricanteForaLista && (
                <Controller
                    name="fabricante"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.fabricante}>
                            <InputLabel htmlFor="equipamentos-fabricante" shrink style={{ color: "#B8B8B8", zIndex: 0 }} >
                                Fabricante
                            </InputLabel>
                            <WhiteInput
                                fullWidth
                                placeholder="Fabricante"
                                type="text"
                                id="equipamentos-fabricante"
                                error={!!errors.fabricante}
                                {...field}
                                readOnly={disableCampos}
                                className={`${errors?.fabricante ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.fabricante ? (
                                <HelperText text={errors?.fabricante?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />
            )}

            {!watchFabricanteForaLista && (
                <Controller
                    name="fabricanteCadastrado"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.fabricante}>
                            <InputLabel htmlFor="fabricanteCadastrado" shrink style={{ color: "#B8B8B8", overflow: 'visible', zIndex: 0 }}>Fabricante</InputLabel>
                            <FabricantesSearchField
                                field={field}
                                id="fabricanteCadastrado"
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                setValue={setFabricanteCadastrado}
                                value={fabricanteCadastrado}
                                editavel={disableCampos}
                                required={errors?.fabricanteCadastrado}
                                className={`${errors?.fabricanteCadastrado ? styles.campoComValorErrado : ""}`}
                                watchTipoEquipamento={watchTipoEquipamento}
                                tipoKey={watchTipoEquipamento?.value || 'all'}
                            />
                            {errors?.fabricanteCadastrado ? (
                                <HelperText text={"Este campo é obrigatório"} />
                            ) : ''}
                        </FormControl>
                    )}
                />
            )}

            <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.modelo}>
                <InputLabel htmlFor="equipamentos-modelo" shrink style={{ color: "#B8B8B8", zIndex: 0 }} >
                    Modelo
                </InputLabel>
                <WhiteInput
                    fullWidth
                    placeholder="Modelo"
                    type="text"
                    id="equipamentos-modelo"
                    {...register("modelo")}
                    readOnly={disableCampos}
                />
            </FormControl>

            <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.fases}>
                <InputLabel htmlFor="equipamentos-fases" shrink style={{ color: "#B8B8B8", zIndex: 0 }} >
                    Nº de fases
                </InputLabel>
                <Controller
                    name="fases"
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            error={!!errors.fases}
                            options={options}
                            styles={selectStyles}
                            placeholder="Selecione o Nº de fases"
                            readOnly={disableCampos}
                            isDisabled={disableCampos}
                            className={`${errors?.fases ? styles.campoComValorErrado : ""}`}
                        />
                    )}
                />
                {errors?.fases ? (
                    <HelperText text={"Este campo é obrigatório"} />
                ) : ''}
            </FormControl>

            <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.tipo}>
                <InputLabel htmlFor="equipamentos-data" shrink style={{ color: "#b8b8b8", zIndex: 0 }}>
                    Data certificação
                </InputLabel>
                <Controller
                    name="dataCertificacao"
                    control={control}
                    render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <DatePicker
                                {...field}
                                error={!!errors.dataCertificacao}
                                inputFormat="dd/MM/yyyy"
                                label="Data certificação"
                                readOnly={disableCampos}
                                renderInput={({ inputRef, inputProps, InputProps }) => (
                                    <>
                                        <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#fff" }} className={`${errors?.dataCertificacao ? styles.campoComValorErrado : ""}`} />
                                        <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                            {InputProps?.endAdornment}
                                        </span>
                                    </>
                                )}
                            />
                        </LocalizationProvider>
                    )}
                />
                {errors?.dataCertificacao ? (
                    <HelperText text={errors?.dataCertificacao?.message} />
                ) : ''}
            </FormControl>
            <Controller
                name="potencia"
                control={control}
                render={({ field }) => (
                    <FormControl variant="outlined" style={{ margin: '28px 44px 0 44px' }} className={styles.potencia}>
                        <InputLabel htmlFor="equipamentos-potencia" shrink style={{ color: "#B8B8B8", zIndex: 0 }} >
                            Potência (kW)
                        </InputLabel>
                        <WhiteInput
                            fullWidth
                            placeholder="Potência"
                            type="number"
                            id="equipamentos-potencia"
                            error={!!errors.potencia}
                            {...field}
                            readOnly={disableCampos}
                            className={`${errors?.potencia ? styles.campoComValorErrado : ""}`}
                        />
                        {errors?.potencia ? (
                            <HelperText text={errors?.potencia?.message} />
                        ) : ''}
                    </FormControl>
                )}
            />
        </div>
    )
}

export { Geral }